const generateNewSessionId = () => {
  return Math.random().toString(36).substring(2, 15);
};
export const debounce = (func, delay) => {
  let inDebounce;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};
export const removeMiscellaneousText = (text) => {
  if (!text) {
    return "";
  }
  let cleanedText = text
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      ""
    )
    .trim();
  cleanedText = cleanedText.replace(/^(Kano\s*:?"?\s*)/, "");
  return cleanedText;
};
export const generateSessionId = (setSessionId) => {
  const newSessionId = generateNewSessionId();
  setSessionId(newSessionId);
};

export const displayCustomiseFirstMessageInGTKY = (
  firstMessage,
  promptType,
  gettingToKnowResume
) => {
  return (
    firstMessage &&
    promptType !== "open-conversation" &&
    gettingToKnowResume !== true
  );
};
